import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { goodsService } from 'shared/src/api';
import type { GetRankingGoodsRequest } from 'shared/src/api';

/**
 * 랭킹 페이지네이션 커서. 네이티브 `GoodsAPI.getGoodsList` 와 동일하게 마지막 아이템의
 * `sno` + `ranking` 을 함께 넘긴다. 첫 페이지는 커서 없이(`null`) 요청한다.
 */
type RankingGoodsPageParam = {
  lastSno: number;
  lastRanking: number;
} | null;

export const useRankingGoods = (
  params: Omit<GetRankingGoodsRequest, 'last_ranking' | 'last_sno'>,
) => {
  return useInfiniteQuery({
    queryKey: queryKey.rankingGoods(params),
    queryFn: ({ pageParam }) =>
      goodsService.getRankingGoods({
        ...params,
        last_ranking: pageParam?.lastRanking,
        last_sno: pageParam?.lastSno,
      }),
    initialPageParam: null as RankingGoodsPageParam,
    getNextPageParam: lastPage => {
      const lastGoods = lastPage.goods[lastPage.goods.length - 1];
      return lastGoods
        ? { lastSno: lastGoods.sno, lastRanking: lastGoods.ranking }
        : undefined;
    },
    select: data => ({
      ...data.pages[data.pages.length - 1],
      goods: data.pages.flatMap(page => page.goods),
    }),
  });
};
